import classnames from 'classnames2';
import React from 'react';

import { IBaseProps } from '../utils';

import styles from './Icon.module.scss';
import { IconSVGs } from './IconSVGs';

export interface IIconProps extends IBaseProps {
  /** Determines icon displayed, see possible values above. */
  icon: keyof typeof IconSVGs;
  /** Determines if icon is hidden to screenreader */
  ariaHidden?: boolean;
  /** Label to be read by screenreader */
  ariaLabel?: string;
  /** DOM ID of object that labels icon */
  ariaLabelledby?: string;
  /** Data test attribute */
  dataTest?: string;
  /** Color of the icon */
  fill?: string;
}

export const Icon: React.FC<IIconProps> = ({
  icon,
  ariaHidden = true,
  ariaLabel,
  ariaLabelledby = null,
  className = '',
  dataTest = '',
  fill
}) => {
  const IconName = IconSVGs[icon];
  const isDecorative = ariaHidden && !ariaLabel && !ariaLabelledby;
  const optionalProps = {
    ...(isDecorative ? { 'aria-hidden': true, focusable: 'false' } : { role: 'img' }),
    ...(ariaLabelledby && { 'aria-labelledby': ariaLabelledby }),
    ...(ariaLabel && { 'aria-label': ariaLabel }),
    ...(dataTest && { 'data-test': dataTest }),
    ...(fill && { fill })
  };
  return <IconName className={classnames(styles.base, className)} {...optionalProps} />;
};
